import { useState } from 'react';

const Search = ({ context, addRank }) => {
  const [data, setData] = useState({
    id: null,
    rank: null,
    type: 'user',
    sport_id: 0,
    province_id: null,
    weight_id: 0,
  });
  return (
    <div className='col-12 col-md-12 my-3'>
      <div className='row'>
        <div className='col-12 col-md-3'>
          <label className='f-13 text-left d-flex flex-row justify-content-start'>
            انتخاب استان
          </label>
          <select
            className='form-control'
            onChange={(e) => {
              setData({
                id: null,
                title: '',
                rank: null,
                ethics_card: 0,
                sport_id: 0,
                province_id: e.target.value,
                weight_id: 0,
              });
            }}
          >
            <option>انتخاب کنید</option>
            {context?.provinces?.map((province) => (
              <option value={province?.id}>{province?.name}</option>
            ))}
          </select>
        </div>
        <div className='col-12 col-md-3 mt-4'>
          <button
            onClick={() => addRank(data)}
            type='submit'
            className='btn bg-purple w-100 f-13 text-white mt-1'
          >
            افزودن به لیست
          </button>
        </div>
      </div>
    </div>
  );
};

export default Search;
